import React, { useState, useEffect } from 'react'
import { Row, Col, ButtonGroup, IconButton, Icon, Table, Uploader, Message } from 'rsuite'
import { isRequiredFiled, isValidFileType } from '../../utils/ValidatorUtils'
import { cloneDeep, forEach, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function ContractChangeExtendPeriodAttach({
  schema,
  titel = 'เอกสารแนบประกอบ',
  isView,
  control,
  errMsg,
  periodBudget = [],
  onDownload = () => {},
  onPreview = () => {},
  onDelete = () => {},
  setAttachValues = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [datas, setDatas] = useState([])
  const [delId, setDelId] = useState([])

  const [otherSeq, setOtherSeq] = useState(2)

  const defaultMaxFileSize = 5
  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const [uploadAttachValues, setUploadAttachValues] = useState(new Map())

  useEffect(() => {
    if (isView) {
      setDatas(schema.values?.filter((e) => !isEmpty(e.filePath)) || [])
    } else {
      setDatas(schema.values || [])
    }
  }, [schema])

  useEffect(() => {
    setAttachValues(uploadAttachValues)
  }, [uploadAttachValues])

  useEffect(() => {
    console.log(
      'periodBudget : ',
      periodBudget.flatMap((x) => x.reasonType).map((x) => String(x).split('-')[0])
    )

    const reasonTypes = [
      ...new Set(periodBudget.flatMap((x) => x.reasonType).map((x) => String(x).split('-')[0])),
    ]

    let val = schema.values?.filter(
      (e) => reasonTypes.includes(e.reasonType) || e.reasonType == '0'
    )

    console.log('val : ', val)

    if (isView) {
      setDatas(val?.filter((e) => !isEmpty(e.filePath)) || [])
    } else {
      setDatas(val || [])
    }
  }, [periodBudget])

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        {datas && (
          <Col xs={24} sm={24} md={24} lg={24}>
            <b style={{ marginTop: 8 }}>{schema?.header || titel}</b>

            {!isView && (
              <Message
                type="info"
                showIcon
                description={`ชนิดไฟล์ที่รองรับ ${schema.fileType || defaultSupportType} ขนาดไฟล์เกิน ${schema.fileSize || defaultMaxFileSize} MB`}
                style={{ marginBottom: 10, marginTop: 10 }}
              />
            )}

            {errMsg && (
              <Message
                type="error"
                showIcon
                description={errMsg}
                style={{ marginBottom: 10, marginTop: 10 }}
              />
            )}

            <Table
              // height={400}
              autoHeight
              wordWrap
              bordered
              data={datas}
              style={{ marginBottom: 10 }}
            >
              <Column width={95} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>
              <Column width={380} flexGrow={1}>
                <HeaderCell>ประเภทไฟล์</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return isView
                      ? rowData.typeName
                      : isRequiredFiled(rowData.isRequired, rowData.typeName)
                  }}
                </Cell>
              </Column>
              <Column width={380}>
                <HeaderCell>ชื่อไฟล์</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (uploadAttachValues.get(rowData.id)?.file?.length > 0) {
                      return uploadAttachValues.get(rowData.id).file[0].blobFile.name
                    } else if (!delId?.includes(rowData.id)) {
                      return rowData.fileName
                    }
                  }}
                </Cell>
              </Column>

              <Column width={160} align="center" fixed="right">
                <HeaderCell></HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    var file = uploadAttachValues.get(rowData.id)?.file

                    // if (isView) {
                    //   if (rowData.filePath) {
                    //     return (
                    //       <ButtonGroup>
                    //         <IconButton
                    //           appearance="ghost"
                    //           icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                    //           onClick={(e) => onPreview(rowData)}
                    //         />
                    //         <IconButton
                    //           appearance="ghost"
                    //           icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    //           onClick={(e) => onDownload(rowData)}
                    //         />
                    //       </ButtonGroup>
                    //     )
                    //   } else {
                    //     return ''
                    //   }
                    // } else

                    if (
                      isView ||
                      (file && file[0]?.blobFile) ||
                      (rowData.filePath && !delId?.includes(rowData.id))
                    ) {
                      return (
                        <>
                          <ButtonGroup>
                            <IconButton
                              appearance="ghost"
                              icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                              onClick={(e) => {
                                if (file && file[0]?.blobFile) {
                                  const url = URL.createObjectURL(file[0].blobFile)
                                  window.open(url)
                                } else {
                                  onPreview(rowData)
                                }
                              }}
                            />
                            {rowData.filePath && !delId?.includes(rowData.id) && (
                              <IconButton
                                appearance="ghost"
                                icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                                onClick={(e) => onDownload(rowData)}
                              />
                            )}

                            {!isView && (
                              <IconButton
                                appearance="ghost"
                                icon={
                                  <Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />
                                }
                                className="rs-btn-ghost-cancel"
                                onClick={(e) => {
                                  if (file && file[0]?.blobFile) {
                                    var map = cloneDeep(uploadAttachValues)
                                    map.delete(rowData.id)
                                    setUploadAttachValues(map)
                                  } else {
                                    setDelId([...new Set([rowData.id, ...delId])])
                                    onDelete(rowData)
                                  }

                                  if (rowData.typeId == '99' && rowData.id != 'NEW_99_1') {
                                    var dataList = [...datas]

                                    dataList.splice(index, 1)

                                    setDatas(dataList)
                                  }
                                }}
                              />
                            )}
                          </ButtonGroup>
                        </>
                      )
                    } else {
                      return (
                        <Row>
                          <Col
                            xs={rowData.typeId == '99' && rowData.id != 'NEW_99_1' ? 12 : 24}
                            sm={rowData.typeId == '99' && rowData.id != 'NEW_99_1' ? 12 : 24}
                            md={rowData.typeId == '99' && rowData.id != 'NEW_99_1' ? 12 : 24}
                            lg={rowData.typeId == '99' && rowData.id != 'NEW_99_1' ? 12 : 24}
                          >
                            <Uploader
                              key={rowData.id}
                              name={rowData.id}
                              autoUpload={false}
                              listType="text"
                              draggable
                              fileList={uploadAttachValues.get(rowData.id)?.file || []}
                              accept={schema.fileType || defaultSupportType}
                              onChange={(fileList) => {
                                if (isEmpty(fileList)) {
                                  // props.onChange(undefined)

                                  var map = cloneDeep(uploadAttachValues)
                                  map.delete(rowData.id)
                                  setUploadAttachValues(map)
                                } else {
                                  let file = fileList[fileList.length - 1]
                                  if (
                                    file.blobFile.size >
                                    (schema.fileSize || defaultMaxFileSize) * 1024 * 1024
                                  ) {
                                    notification.open('error', {
                                      title: `ขนาดไฟล์เกิน ${schema.fileSize || defaultMaxFileSize} MB`,
                                    })

                                    return
                                  } else if (
                                    isValidFileType(
                                      file.blobFile.type,
                                      schema.fileType || defaultSupportType
                                    )
                                  ) {
                                    // props.onChange([file])

                                    var map = cloneDeep(uploadAttachValues)
                                    map.set(rowData.id, { typeId: rowData.typeId, file: [file] })
                                    setUploadAttachValues(map)
                                  } else {
                                    notification.open('error', {
                                      title: `ชนิดไฟล์ที่รองรับ ${schema.fileType || defaultSupportType}`,
                                    })
                                  }
                                }
                              }}
                            >
                              <div style={{ lineHeight: '10px' }}>
                                <Icon size="2x" icon="upload2" />
                              </div>
                            </Uploader>
                          </Col>

                          {rowData.typeId == '99' && rowData.id != 'NEW_99_1' && (
                            <Col xs={12} sm={12} md={12} lg={12}>
                              <IconButton
                                appearance="ghost"
                                icon={
                                  <Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />
                                }
                                style={{ marginTop: 5 }}
                                className="rs-btn-ghost-cancel"
                                onClick={(e) => {
                                  var dataList = [...datas]

                                  dataList.splice(index, 1)

                                  setDatas(dataList)
                                }}
                              />
                            </Col>
                          )}
                        </Row>
                      )
                    }
                  }}
                </Cell>
              </Column>
            </Table>
            {!isView && (
              <SaveButton
                icon="plus"
                children="เพิ่มเอกสารอื่นๆ"
                onClick={() => {
                  var dataList = [...datas]
                  var other = dataList.findLast((e) => e.typeId == '10-99')

                  dataList.push({
                    id: 'NEW_99_' + otherSeq,
                    typeId: other?.typeId,
                    typeName: other?.typeName,
                    fileName: null,
                    filePath: null,
                    isRequired: false,
                    isEnableDel: false,
                  })

                  setOtherSeq(otherSeq + 1)

                  setDatas(dataList)
                }}
              />
            )}
          </Col>
        )}
      </Row>
    </>
  )
}
